import { AlertName, AlertType } from "./alert-type";

const restrictedTriggerAlertTypeIds = new Set([
  AlertType[AlertName.ProctoringSessionPaused].id,
  AlertType[AlertName.ProctoringSessionResumed].id,
  AlertType[AlertName.ProctoringSessionExtended].id,
  AlertType[AlertName.ProctorApprovalCompleted].id,
  AlertType[AlertName.SessionTerminated].id,
  AlertType[AlertName.SessionCompleted].id
]);
const restrictedTriggerEventNames = new Set([
  "pause",
  "resume",
  "extend",
  "extendalert",
  "approval",
  "stop",
  "terminate",
  "terminated",
  "complete",
  "completed",
  "sessioncomplete",
  "sessioncompleted"
]);

const isRestrictedTriggerEvent = (eventNames: string, data: any) => {
  const eventNameList = eventNames
    .split(" ")
    .map((eventName: string) => eventName.trim())
    .filter(Boolean);

  if (typeof data?.alert_type_id === "number" && restrictedTriggerAlertTypeIds.has(data.alert_type_id)) {
    return true;
  }

  return eventNameList.some((eventName) => {
    const normalizedEventName = eventName.toLowerCase();
    if (restrictedTriggerEventNames.has(normalizedEventName)) {
      return true;
    }

    const matchedAlertTypeId = normalizedEventName.match(/^log:event:type:(\d+)$/);
    if (!matchedAlertTypeId) {
      return false;
    }

    return restrictedTriggerAlertTypeIds.has(Number(matchedAlertTypeId[1]));
  });
};

export { isRestrictedTriggerEvent, restrictedTriggerAlertTypeIds };
